import { ChangeEvent } from 'react';
import { Control, Controller } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { ToolbarFields } from 'components/FilterSummary';
import TimesheetFilter from 'components/TimesheetFilter/TimesheetChipsFilter';
import { FormDataProps, TimsheetsFilter } from './types';

interface TimesheetPickersProps {
  fields: TimsheetsFilter[];
  control: Control<FormDataProps>;
  loading: boolean;
}

// Client, project and employee pickers; they sit in the table's top row,
// beside the paging stats.
const TimesheetPickers = ({
  fields,
  control,
  loading,
}: TimesheetPickersProps) => {
  const intl = useIntl();

  return (
    <ToolbarFields>
      {fields.map((entry) => (
        <Controller
          key={entry.type}
          name={entry.type}
          control={control}
          type={entry.type}
          render={({ value, name, onChange }) => {
            const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
              onChange(e);
              if (entry.handleChange) {
                entry.handleChange();
              }
            };
            return (
              <TimesheetFilter
                label={intl.formatMessage({ id: entry.label })}
                value={value}
                type={name}
                onChange={handleChange}
                options={entry.options ?? []}
                disabled={loading}
                size="small"
              />
            );
          }}
        />
      ))}
    </ToolbarFields>
  );
};

export default TimesheetPickers;
